(function ($) {
    'use strict';

    $(function () {
        'use strict';

        $(document).on('change', '.js-calcutate', function (event) {
            event.preventDefault();

            var $this = $(this),
                $row = $this.closest('.prod__item'),
                $total_wrapper = $row.find('.js-total_container'),
                unit_price = parseFloat($this.data('unit_price')),
                qty = parseInt($this.val()),
                $total_price;

                $total_price = unit_price * qty;
            $total_wrapper.html($total_price.toFixed(2) + ' лв.');
        });
    });

}(jQuery));